module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_1_preview.6994459a.jpg";